// Optimized viewport settings for Framer Motion to reduce forced reflows
export const optimizedViewport = {
  once: true,
  amount: 0.2,
  margin: "0px 0px -50px 0px"
};
